<div class="ai-header-root flex w-full min-w-0 flex-col">
  @if (network.showOfflineHeader()) {
    <div class="ai-offline-bar" role="status" aria-live="polite">
      {{ offlineHeaderMessage }}
    </div>
  }
  <div class="ai-header-title-row flex w-full min-w-0 items-center gap-12 pt-0 h-full">
    @if (chatState.conversationHeaderTitle(); as title) {
      <h1
        #headerTitleEl
        class="text-[15px] font-semibold text-[var(--p-slate-800)] truncate min-w-0 flex-1 m-0 text-left leading-tight"
        [pTooltip]="title"
        [tooltipDisabled]="!isHeaderTitleClipped(headerTitleEl)"
        tooltipPosition="bottom"
        tooltipStyleClass="conversation-title-tooltip"
      >
        {{ title }}
      </h1>
    } @else {
      <span class="flex-1 min-w-0"></span>
    }
  </div>
</div>
